import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'templates-Series': {
      listing_title: {
        seriesName: string
      }
      cart_btn_label: void
      sold_out_btn_series: void
      customizable_btn_label: void
      sku_piece_price_label: void
      sku_article_number_label: void
      sku_detail_link: void
      only_for_b2b: string
      only_for_b2c: string
      sku_add_to_wishlist: void
      sku_remove_from_wishlist: void
    }
    stockInfo: {
      available_stock: {
        stock: number
      }
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query templates_Series_translations {
        listing_title: snippet(group: "templates-Series", name: "listing_title")
        cart_btn_label: snippet(
          group: "templates-Series"
          name: "cart_btn_label"
        )
        sold_out_btn_series: snippet(
          group: "templates-Series"
          name: "sold_out_btn_series"
        )
        customizable_btn_label: snippet(
          group: "templates-Series"
          name: "customizable_btn_label"
        )
        sku_piece_price_label: snippet(
          group: "templates-Series"
          name: "sku_piece_price_label"
        )
        sku_article_number_label: snippet(
          group: "templates-Series"
          name: "sku_article_number_label"
        )
        sku_detail_link: snippet(
          group: "templates-Series"
          name: "sku_detail_link"
        )
        sku_add_to_wishlist: snippet(
          group: "templates-Series"
          name: "sku_add_to_wishlist"
        )
        sku_remove_from_wishlist: snippet(
          group: "templates-Series"
          name: "sku_remove_from_wishlist"
        )
        available_stock: snippet(group: "stockInfo", name: "available_stock")
        only_for_b2b: snippet(group: "templates-Series", name: "only_for_b2b")
        only_for_b2c: snippet(group: "templates-Series", name: "only_for_b2c")
      }
    `)
  )
